(function(angular) {
    'use strict';

    /**
     * Helper service for abstracting code related to tracking cart events
     */
    angular
        .module('enervee')
        .factory('CartAnalyticsService', cartAnalyticsService);

    cartAnalyticsService.$inject = [
        'AnalyticsService',
        'CategoriesService',
        'CartService',
        'SwiftypeService',
        'UtilService',
    ];
    function cartAnalyticsService(
        AnalyticsService,
        CategoriesService,
        CartService,
        SwiftypeService,
        UtilService
    ) {
        var _pub = {};

        /**
         * Adds total_items and cartId to event properties
         * @param {String} eventName 
         * @param {Object} eventProperties 
         */
        _pub.reportEvent = function (eventName, eventProperties) {
            return getSwiftypeProducts().then(cartSwiftypeProducts => {
                eventProperties.total_items = CartService.cartDetails.itemCount;
                eventProperties.cartId = CartService.cartDetails.cartId;
                return AnalyticsService.reportEvent(eventName, eventProperties, cartSwiftypeProducts);
            });
        };

        /**
         * Gets the list of product properties that we want to include in the main event and
         * builds a list of products for the event.
         * @param {String} eventName 
         * @param {Object} eventProperties 
         */
        _pub.reportEventWithProducts = (eventName, eventProperties={}) => {
            const productKeys = UtilService.getSiteSetting('iterable_product_properties', []);
            return getSwiftypeProducts().then(cartSwiftypeProducts => {
                const productsObj = cartSwiftypeProducts.map(product => {
                    const returnObj = {};
                    productKeys.forEach(key => {
                        returnObj[key] = product[key] || null;
                    });
                    return returnObj;
                });
                eventProperties.products = JSON.stringify(productsObj);
                return AnalyticsService.reportEvent(eventName, eventProperties);
            });
        };

        /**
         * Gets cart products by id and modifies the object to use category code instead of id
         */
        function getProductsByCategoryCode() {
            let cartItemsByCategory = CartService.getProductIdsByCategoryId();
            cartItemsByCategory = UtilService.replaceKeys(cartItemsByCategory, function (categoryId) {
                return CategoriesService.getCategoryById(categoryId).code;
            });
            return cartItemsByCategory
        }

        /**
         * Gets products from swiftype
         */
        function getSwiftypeProducts() {
            const cartItemsByCategory = getProductsByCategoryCode();
            // Get a copy of the cart items array _before_ the call to swiftype
            const cartItems = CartService.getItems().slice(0);
            return SwiftypeService.getProducts(cartItemsByCategory).then(function (swiftypeProducts) {
                return cartItems.map(function (product) {
                    const swiftypeProduct = swiftypeProducts[product.id];
                    if (swiftypeProduct) {
                        swiftypeProduct.quantity = product.quantity;
                    }
                    return swiftypeProduct;
                }).filter(function (product) {
                    // Filter out any `null` or `undefined` values
                    return !!product;
                });
            });
        }

        return _pub;
    }
})(angular);